const gtag = (...args) => window.gtag?.(...args);

export const trackPageView = (path, search) => {
  const params = new URLSearchParams(search);
  const extra = {};

  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(p => {
    if (params.get(p)) extra[p] = params.get(p);
  });

  if (params.get('fbclid')) extra.fbclid = params.get('fbclid');

  gtag('event', 'page_view', { page_path: path, page_location: window.location.href, ...extra });
};

export const trackEvent = (category, action, label = null) => {
  gtag('event', action, { event_category: category, event_label: label });
};

